/*
 * Once Upon Magic — proprietary source code.
 * Copyright © 2026 Once Upon Magic. Unauthorized reproduction or adaptation prohibited.
 * TDM rights reserved. OUM-FP: OUM-20260817-WISHLIST-514A55B27783
 */
import { CartErrorEvent, CartLinesUpdateEvent } from '@shopify/events';

(function () {
  var STORAGE_KEY = 'oum_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch (e) { return []; }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    if (typeof window.__updateWishlistHeaderCount === 'function') {
      window.__updateWishlistHeaderCount();
    }
  }

  function isInWishlist(handle) {
    return getWishlist().some(function (p) { return p.handle === handle; });
  }

  function addToWishlist(product) {
    var list = getWishlist();
    if (!isInWishlist(product.handle)) { list.push(product); saveWishlist(list); }
  }

  function removeFromWishlist(handle) {
    saveWishlist(getWishlist().filter(function (p) { return p.handle !== handle; }));
  }

  function toggleWishlist(product) {
    if (isInWishlist(product.handle)) { removeFromWishlist(product.handle); return false; }
    else { addToWishlist(product); return true; }
  }

  function updateWishlistHeaderCount() {
    var count = getWishlist().length;
    var headerIcon = document.getElementById('wishlist-header-icon');
    var countBadge = document.getElementById('wishlist-header-count');

    if (headerIcon) {
      headerIcon.classList.toggle('has-items', count > 0);
    }

    if (countBadge) {
      countBadge.textContent = count > 99 ? '99+' : String(count);
      countBadge.style.display = count > 0 ? 'flex' : 'none';
    }
  }

  function pulseWishlistHeader(headerIcon) {
    if (!headerIcon) return;
    headerIcon.classList.remove('wishlist-header-icon--pop');
    void headerIcon.offsetWidth;
    headerIcon.classList.add('wishlist-header-icon--pop');
    setTimeout(function () {
      headerIcon.classList.remove('wishlist-header-icon--pop');
    }, 500);
  }

  function animateToWishlist(source) {
    var destination = document.getElementById('wishlist-header-icon');
    if (!destination || !source) return;

    var sourceRect = source.getBoundingClientRect();
    var destinationRect = destination.getBoundingClientRect();
    var startX = sourceRect.left + sourceRect.width / 2;
    var startY = sourceRect.top + sourceRect.height / 2;
    var endX = destinationRect.left + destinationRect.width / 2;
    var endY = destinationRect.top + destinationRect.height / 2;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var duration = reducedMotion ? 360 : 720;
    var arcHeight = reducedMotion ? 0 : Math.min(90, Math.max(48, Math.abs(endY - startY) * 0.15));
    var flyHeart = document.createElement('span');
    var sourceIcon = source.querySelector('svg');

    flyHeart.className = 'wishlist-fly-heart';
    flyHeart.setAttribute('aria-hidden', 'true');
    flyHeart.style.left = startX + 'px';
    flyHeart.style.top = startY + 'px';

    if (sourceIcon) {
      flyHeart.appendChild(sourceIcon.cloneNode(true));
    } else {
      flyHeart.textContent = '\u2665';
    }

    document.body.appendChild(flyHeart);

    if (typeof flyHeart.animate !== 'function') {
      flyHeart.remove();
      pulseWishlistHeader(destination);
      return;
    }

    var animation = flyHeart.animate([
      {
        left: startX + 'px',
        top: startY + 'px',
        transform: 'translate(-50%, -50%) scale(1)',
        opacity: 1
      },
      {
        left: startX + (endX - startX) * 0.55 + 'px',
        top: startY + (endY - startY) * 0.55 - arcHeight + 'px',
        transform: 'translate(-50%, -50%) scale(0.82)',
        opacity: 1,
        offset: 0.55
      },
      {
        left: endX + 'px',
        top: endY + 'px',
        transform: 'translate(-50%, -50%) scale(0.24)',
        opacity: 0.8
      }
    ], {
      duration: duration,
      easing: 'cubic-bezier(0.22, 0.78, 0.34, 1)',
      fill: 'forwards'
    });
    var completed = false;

    function finishAnimation() {
      if (completed) return;
      completed = true;
      flyHeart.remove();
      pulseWishlistHeader(destination);
    }

    animation.onfinish = finishAnimation;
    animation.oncancel = finishAnimation;
    setTimeout(finishAnimation, duration + 120);
  }

  window.__updateWishlistHeaderCount = updateWishlistHeaderCount;

  function updateAllButtons(handle) {
    var inList = isInWishlist(handle);
    document.querySelectorAll('.wishlist-btn[data-handle="' + handle + '"]').forEach(function (btn) {
      btn.classList.toggle('wishlist-btn--active', inList);
      btn.setAttribute('aria-pressed', inList ? 'true' : 'false');
    });
  }

  function initButtons() {
    document.querySelectorAll('.wishlist-btn').forEach(function (btn) {
      var handle = btn.getAttribute('data-handle');
      if (handle) {
        btn.classList.toggle('wishlist-btn--active', isInWishlist(handle));
        btn.setAttribute('aria-pressed', isInWishlist(handle) ? 'true' : 'false');
      }
    });
  }

  function addToCart(variantId, btn) {
    btn.disabled = true;
    btn.textContent = btn.getAttribute('data-loading-text') || '...';

    var sectionIds = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (item) {
      var sectionId = item.getAttribute('data-section-id');
      if (sectionId && sectionIds.indexOf(sectionId) === -1) {
        sectionIds.push(sectionId);
      }
    });

    var deferredEventPromise = CartLinesUpdateEvent.createPromise();
    btn.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: String(variantId), quantity: 1 }],
      promise: deferredEventPromise.promise
    }));

    var addResponse;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: sectionIds.join(','),
        sections_url: window.location.pathname
      })
    })
    .then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) {
          throw new Error(data.description || data.message || 'Ajout au panier impossible');
        }
        return data;
      });
    })
    .then(function (response) {
      addResponse = response;
      return fetch('/cart.js', {
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      });
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Mise à jour du panier impossible');
      return res.json();
    })
    .then(function (cart) {
      deferredEventPromise.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          source: 'wishlist',
          itemCount: 1,
          sections: addResponse.sections,
          didError: false
        }
      });

      btn.textContent = btn.getAttribute('data-added-text') || 'Ajouté !';
      btn.classList.add('wishlist-atc--added');
      setTimeout(function () {
        btn.textContent = btn.getAttribute('data-add-text') || 'Ajouter au panier';
        btn.classList.remove('wishlist-atc--added');
        btn.disabled = false;
      }, 2000);
    })
    .catch(function (error) {
      deferredEventPromise.reject(error);
      btn.dispatchEvent(new CartErrorEvent({
        error: error.message || 'Ajout au panier impossible',
        code: 'SERVICE_UNAVAILABLE'
      }));
      btn.textContent = btn.getAttribute('data-error-text') || 'Erreur';
      btn.disabled = false;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.wishlist-btn');
    if (!btn) return;
    var handle = btn.getAttribute('data-handle');
    if (!handle) return;
    var wasAdded = toggleWishlist({
      handle: handle,
      title: btn.getAttribute('data-title'),
      image: btn.getAttribute('data-image'),
      price: btn.getAttribute('data-price'),
      url: btn.getAttribute('data-url'),
      variant_id: btn.getAttribute('data-variant-id')
    });
    updateAllButtons(handle);
    if (wasAdded) {
      animateToWishlist(btn);
    }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.wishlist-atc-btn');
    if (!btn) return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    addToCart(variantId, btn);
  });

  function renderWishlistPage() {
    var container = document.getElementById('wishlist-page-container');
    if (!container) return;
    var list = getWishlist();
    var emptyText = container.getAttribute('data-empty-text') || 'Votre liste de favoris est vide.';
    var shopText = container.getAttribute('data-shop-text') || 'Découvrir les produits';
    var shopUrl = container.getAttribute('data-shop-url') || '/collections/all';
    var addText = container.getAttribute('data-add-text') || 'Ajouter au panier';
    var addedText = container.getAttribute('data-added-text') || 'Ajouté !';
    var loadingText = container.getAttribute('data-loading-text') || '...';
    var errorText = container.getAttribute('data-error-text') || 'Erreur';

    if (list.length === 0) {
      var emptyState = document.createElement('div');
      var emptyIcon = document.createElement('span');
      var emptyMessage = document.createElement('p');
      var shopLink = document.createElement('a');

      emptyState.className = 'wishlist-empty';
      emptyIcon.className = 'wishlist-empty__icon';
      emptyIcon.setAttribute('aria-hidden', 'true');
      emptyIcon.textContent = '\u2661';
      emptyMessage.className = 'wishlist-empty__message';
      emptyMessage.textContent = emptyText;
      shopLink.className = 'wishlist-empty__cta';
      shopLink.href = shopUrl;
      shopLink.textContent = shopText;

      emptyState.appendChild(emptyIcon);
      emptyState.appendChild(emptyMessage);
      emptyState.appendChild(shopLink);
      container.replaceChildren(emptyState);
      return;
    }

    var html = '<div class="wishlist-grid">';
    list.forEach(function (p) {
      html += '<div class="wishlist-card">';
      html += '<a href="' + p.url + '" class="wishlist-card__image-link">';
      if (p.image) html += '<img src="' + p.image + '" alt="' + p.title + '" class="wishlist-card__image" loading="lazy">';
      html += '</a>';
      html += '<div class="wishlist-card__info">';
      html += '<a href="' + p.url + '" class="wishlist-card__title">' + p.title + '</a>';
      html += '<p class="wishlist-card__price">' + p.price + '</p>';
      html += '</div>';
      if (p.variant_id) {
        html += '<button class="wishlist-atc-btn"'
          + ' data-variant-id="' + p.variant_id + '"'
          + ' data-add-text="' + addText + '"'
          + ' data-added-text="' + addedText + '"'
          + ' data-loading-text="' + loadingText + '"'
          + ' data-error-text="' + errorText + '"'
          + '>' + addText + '</button>';
      }
      html += '<button class="wishlist-card__remove" data-handle="' + p.handle + '" aria-label="Retirer">';
      html += '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';
      html += '</button>';
      html += '</div>';
    });
    html += '</div>';
    container.innerHTML = html;

    container.querySelectorAll('.wishlist-card__remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        removeFromWishlist(btn.getAttribute('data-handle'));
        renderWishlistPage();
        if (typeof window.__updateWishlistHeaderCount === 'function') {
          window.__updateWishlistHeaderCount();
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initButtons();
    renderWishlistPage();
    if (typeof window.__updateWishlistHeaderCount === 'function') {
      window.__updateWishlistHeaderCount();
    }
  });

  window.__oumWishlist = { getWishlist: getWishlist, isInWishlist: isInWishlist };
})();
